module.exports = "<div class=\"ribbon\" *ngIf=\"ribbonEnv\"> <a href=\"\" jhiTranslate=\"global.ribbon.{{ribbonEnv}}\">{{ribbonEnv}}</a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/main/ribbon.component.html
// module id = 356
// module chunks = 0